var map = {
	"./images/logo_top.png": "ef96",
	"./images/skin-B/logo_top.png": "ff01",
	"./images/skin-G/logo_top.png": "070d",
	"./images/skin-Gift/logo_top.png": "0688",
	"./images/skin-O/logo_top.png": "42f8",
	"./images/skin-T/logo_top.png": "deea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "42dc";